export default function ChatMessage({ message, role }) {
    // Use 'U' for the user and 'A' for the assistant
    const roleIcon = role === "user" ? (
      <div className="rounded-full h-8 w-8 bg-slate-600 flex items-center justify-center font-semibold text-slate-300 shrink-0">AZT</div>
    ) : (
      <div className="rounded-full h-8 w-8 bg-pink-600 flex items-center justify-center font-semibold text-slate-50 shrink-0">C</div>
    );
  
    // "User" for the person and "Assistant" for the GPT assistant
    const roleName = role === "user" ? "Agent de vanzari AZT" : "Client Potential";
  
    return (
      <div className="flex flex-row mx-2 my-4">
        {roleIcon}
        <div className="p-1 ml-2">
          <div className="flex-col">
            <p className="font-semibold text-slate-400">{roleName}</p>
            <p className="text-slate-50">
              {message}  {/* Render the message as simple text */}
            </p>
          </div>
        </div>
      </div>
    );
  }
  